// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__8XZMD","newNotify":"Notification_newNotify__wTtHu"};